export default "__VITE_ASSET__44544dce__"